import type { FaireProductEntity } from "../../entity_types/product";

export const p_pby3eqmbyr: FaireProductEntity = {
  token: "p_pby3eqmbyr",
  type: "product",
  name: "LA CONDESA",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/9dbf79e5a2afbdd20452b42eba6a80b3e3c81664a0f813c210005a4dbd7fb092.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a99c3db244b6406c75b70c19cbf947bc0ac214d75a58ca4b4d9cae3d7dc1e1d.jpeg",
    "https://cdn.faire.com/fastly/b97ee335710055e264af4fe0d26621ea14853961bd0fe0e61d78d3597dc2a24e.jpeg",
    "https://cdn.faire.com/fastly/a1f56041a8d1618d3a036796bb6dc331c4166209d1fec5b1de419b50e0a79a8b.jpeg",
  ],
  priceDollars: 19,
  description:
    "A canopy of tree-lined avenues, vibrant art deco facades and charming sidewalk cafes. Wander the neighborhood of La Condesa with its European-esque streets and leafy promenades. This scent will infinitely lift your spirits with bright notes of citrus, soft white florals and lush greenery.\n\n• Narcissus,\n• navelina orange blossom,\n• kumquat,\n• cassis,\n• neroli\n\nIllustrations by fellow dreamer Freddy Terriquez; when he's not packing candles he's sketching some of our favorite designs.\n\nThese beautiful hand-painted jars are designed to be re-loved and reused.\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n8 ounces (226g), comes in our signature Mexico City box.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:43.322Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
